import { Rows3 } from "lucide-react";
import { RiForward5Line } from "react-icons/ri";

export default {
    row1 : [

    {
        column: "column1",
        columnWidth:"100%",

        rows: {
            row1: [
                {
                    name: "importNoteDate",
                    label: "Date",
                    component: "dateselector",
                    width:"100%"

                },
            ],

            row2: [
                {
                    name: "importNotesPredefined",
                    label: "Predefined Notes",
                    component: "text-field",


                },
            ],

            
            row3: [{
                name: "importNotes",
                actionText: "Notes",
                component: "textarea",
                height: "100px",
                sx :{
                    borderRadius : "10px"
                },
                required:true,

            }],
            row4: [
                {
                    name: "importNoteAttachment",
                    label: "Attached",
                    component: "fileselector",
                    width:"100%"

                }
            ]
        }
        
        
    },
    
]
}
               



